import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://mhpaituddudtamoiwdut.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFub24iLCJpYXQiOjE3NzcyNjUxNTEsImV4cCI6MjA5Mjg0MTE1MX0.fV433dD7OyuiROGrOhhO6aS90qeEzbz6vlGhqZJJ7B4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
